import React from 'react';
import { Box, Typography, Paper, Button, Container } from '@mui/material';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LoginIcon from '@mui/icons-material/Login';

const ACTION_MESSAGES = {
  upgrade: (planName) =>
    planName
      ? `Your subscription has been upgraded to ${planName}.`
      : 'Your subscription has been upgraded.',
  add_credits: () => 'New credits added successfully.',
  add_user: () => 'New user seats added.',
  renew: () => 'Subscription renewed.',
};

const getSuccessMessage = (action, planName) => {
  const key = (action || '').toLowerCase().trim();
  const fn = ACTION_MESSAGES[key];
  return fn ? fn((planName || '').trim()) : 'Your payment has been processed.';
};

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  // Read from both useSearchParams and location.search so params are available after Razorpay redirect
  const action = searchParams.get('action') || new URLSearchParams(location.search).get('action') || '';
  const planName = searchParams.get('plan_name') || new URLSearchParams(location.search).get('plan_name') || '';
  const message = getSuccessMessage(action, planName);

  const handleClick = () => {
    if (user) {
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/auth/login', { state: { from: { pathname: '/dashboard' } }, replace: true });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#f3f6fb',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: 'center',
            backgroundColor: '#fff',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <CheckCircleOutlineIcon
              sx={{ fontSize: 72, color: 'success.main' }}
              aria-hidden
            />
          </Box>
          <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
            Payment successful
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {message}
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={user ? <DashboardIcon /> : <LoginIcon />}
            onClick={handleClick}
            sx={{ py: 1.5, minWidth: 200 }}
          >
            {user ? 'Go to Dashboard' : 'Go to Login'}
          </Button>
          {!user && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Log in to access your dashboard.
            </Typography>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentSuccess;
